var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    width: 24,
    height: 24,
    transform: "translate(19 46)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4741",
    "data-name": "Mask Group 4741",
    transform: "translate(-19 -46)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag",
    transform: "translate(2.258 29.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8227",
    "data-name": "Path 8227",
    d: "M37.167,32.758v3.576a1.477,1.477,0,0,1-.434,1.047l-7.92,7.92a1.481,1.481,0,0,1-2.095,0l-6.285-6.285a1.481,1.481,0,0,1,0-2.095L28.354,29a1.477,1.477,0,0,1,1.047-.434h4.19A1.477,1.477,0,0,1,34.639,29h0l1.047,1.047",
    transform: "translate(0 -8.251)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_818",
    "data-name": "Line 818",
    y1: 1.047,
    x2: 1.047,
    transform: "translate(28.813 27.624)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8228",
    "data-name": "Path 8228",
    d: "M137.76,192.591a1.481,1.481,0,0,1-2.095,0L133.57,190.5a1.481,1.481,0,0,1,0-2.095l2.095-2.095a1.481,1.481,0,0,1,2.095,0l2.095,2.095a1.481,1.481,0,0,1,0,2.095Z",
    transform: "translate(-108.946 -159.73)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_819",
    "data-name": "Line 819",
    x1: 4.148,
    y2: 4.148,
    transform: "translate(33.337 20)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_820",
    "data-name": "Line 820",
    x2: 2.095,
    y2: 2.095,
    transform: "translate(32.29 23.1)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel);
export default __webpack_public_path__ + "static/media/label.e8e58f7f7e5fe0d334df1373f2ab8a8d.svg";
export { ForwardRef as ReactComponent };